import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'
import { SelectDropdown } from '../../../components/SelectDropdown/SelectDropdown'
import { FormFeedback } from '../../../components/Form/FormFeedback'
import { useAdvisorEngineContactCreate } from '../../Integration/IntegrationManagement/IntegrationSpecificSettings/AdvisorEngine/hooks'

export const AdvisorEngineContactCreateFields: React.FC = () => {
  const { savedContactCreate, officeOptions, securityGroupOptions, isFetching } = useAdvisorEngineContactCreate({
    skipConfiguredEntities: true,
  })
  const form = useFormContext()

  const showOffice = !savedContactCreate?.officeId
  const showSecurityGroup = !savedContactCreate?.securityGroupId

  if (!showOffice && !showSecurityGroup) {
    return null
  }

  return (
    <>
      {showOffice ? (
        <Row className='mt-2'>
          <Col>
            <div className='lead-extra-small'>Office</div>
            <Controller
              name='serviceConfig.contactCreate.officeId'
              control={form.control}
              rules={{ required: 'Office is required' }}
              render={({ field, fieldState }) => (
                <>
                  <SelectDropdown
                    options={officeOptions ?? []}
                    initialSelectedOption={officeOptions?.find((option) => option.id === field.value) ?? null}
                    onOptionSelected={(option) => field.onChange(option.id)}
                    placeholder='Select an office'
                    loading={isFetching}
                  />
                  {fieldState.error ? <FormFeedback>{fieldState.error.message}</FormFeedback> : null}
                </>
              )}
            />
          </Col>
        </Row>
      ) : null}
      {showSecurityGroup ? (
        <Row className='mt-2'>
          <Col>
            <div className='lead-extra-small'>Security groups</div>
            <Controller
              name='serviceConfig.contactCreate.securityGroupId'
              control={form.control}
              rules={{ required: 'Security group is required' }}
              render={({ field, fieldState }) => (
                <>
                  <SelectDropdown
                    options={securityGroupOptions ?? []}
                    initialSelectedOption={securityGroupOptions?.find((option) => option.id === field.value) ?? null}
                    onOptionSelected={(option) => field.onChange(option.id)}
                    placeholder='Select a security group'
                    loading={isFetching}
                  />
                  {fieldState.error ? <FormFeedback>{fieldState.error.message}</FormFeedback> : null}
                </>
              )}
            />
          </Col>
        </Row>
      ) : null}
      <Row className='mt-2 mb-3'>
        <Col>
          <span className='paragraph-small zocks-text-gray-600 d-block'>
            These preferences will be saved. You can change them any time in the integration settings.
          </span>
        </Col>
      </Row>
    </>
  )
}
